import { createUseStyles } from 'react-jss'
import { WHITE } from '@omnilert/components'

export default createUseStyles({
  breadcrumbs: {
    display: 'flex',
    '& li': {
      marginRight: 5
    }
  },
  container: {
    backgroundColor: WHITE,
    height: '100%',
    overflowY: 'auto',
    width: '100%',
    padding: '24px'
  },
  responsive: {
    flexDirection: 'column',
    margin: '0 auto'
  }
})

